module.exports = __webpack_public_path__ + "img/map.b1836b10.png";